import * as ambassadorWixBookingsReaderV2ExtendedBooking from './bookings-reader-v2-extended-booking-extended-bookings.http.js';
import * as ambassadorWixBookingsReaderV2ExtendedBookingTypes from './bookings-reader-v2-extended-booking-extended-bookings.types.js';
import * as ambassadorWixBookingsReaderV2ExtendedBookingUniversalTypes from './bookings-reader-v2-extended-booking-extended-bookings.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function query(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBookingsReaderV2ExtendedBookingUniversalTypes.QueryExtendedBookingRequest,
  ambassadorWixBookingsReaderV2ExtendedBookingTypes.QueryExtendedBookingRequest,
  ambassadorWixBookingsReaderV2ExtendedBookingUniversalTypes.QueryExtendedBookingResponse,
  ambassadorWixBookingsReaderV2ExtendedBookingTypes.QueryExtendedBookingResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsReaderV2ExtendedBooking.query(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/extended-booking/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryExtendedBookings(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBookingsReaderV2ExtendedBookingUniversalTypes.QueryExtendedBookingsRequest,
  ambassadorWixBookingsReaderV2ExtendedBookingTypes.QueryExtendedBookingsRequest,
  ambassadorWixBookingsReaderV2ExtendedBookingUniversalTypes.QueryExtendedBookingsResponse,
  ambassadorWixBookingsReaderV2ExtendedBookingTypes.QueryExtendedBookingsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsReaderV2ExtendedBooking.queryExtendedBookings(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/extended-bookings/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function countExtendedBookings(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBookingsReaderV2ExtendedBookingUniversalTypes.CountExtendedBookingsRequest,
  ambassadorWixBookingsReaderV2ExtendedBookingTypes.CountExtendedBookingsRequest,
  ambassadorWixBookingsReaderV2ExtendedBookingUniversalTypes.CountExtendedBookingsResponse,
  ambassadorWixBookingsReaderV2ExtendedBookingTypes.CountExtendedBookingsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsReaderV2ExtendedBooking.countExtendedBookings(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/extended-bookings/count',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  ExtendedBooking as ExtendedBookingOriginal,
  DeferredChargeStatus as DeferredChargeStatusOriginal,
  DeferredChargeStatusWithLiterals as DeferredChargeStatusWithLiteralsOriginal,
  DeferredChargeDeclineReason as DeferredChargeDeclineReasonOriginal,
  DeferredChargeDeclineReasonWithLiterals as DeferredChargeDeclineReasonWithLiteralsOriginal,
  AttendanceStatus as AttendanceStatusOriginal,
  AttendanceStatusWithLiterals as AttendanceStatusWithLiteralsOriginal,
  Booking as BookingOriginal,
  BookingParticipantsInfoOneOf as BookingParticipantsInfoOneOfOriginal,
  MultiServiceBookingType as MultiServiceBookingTypeOriginal,
  MultiServiceBookingTypeWithLiterals as MultiServiceBookingTypeWithLiteralsOriginal,
  BookedEntity as BookedEntityOriginal,
  BookedEntityItemOneOf as BookedEntityItemOneOfOriginal,
  BookedSlot as BookedSlotOriginal,
  BookedResource as BookedResourceOriginal,
  ResourceTransparency as ResourceTransparencyOriginal,
  ResourceTransparencyWithLiterals as ResourceTransparencyWithLiteralsOriginal,
  Location as LocationOriginal,
  LocationType as LocationTypeOriginal,
  LocationTypeWithLiterals as LocationTypeWithLiteralsOriginal,
  PhoneCall as PhoneCallOriginal,
  ResourceSelection as ResourceSelectionOriginal,
  SelectionMethod as SelectionMethodOriginal,
  SelectionMethodWithLiterals as SelectionMethodWithLiteralsOriginal,
  RequestedGenderValue as RequestedGenderValueOriginal,
  RequestedGender as RequestedGenderOriginal,
  RequestedGenderWithLiterals as RequestedGenderWithLiteralsOriginal,
  DurationUnitType as DurationUnitTypeOriginal,
  DurationUnitTypeWithLiterals as DurationUnitTypeWithLiteralsOriginal,
  BookedSchedule as BookedScheduleOriginal,
  ContactDetails as ContactDetailsOriginal,
  Address as AddressOriginal,
  AddressStreetOneOf as AddressStreetOneOfOriginal,
  StreetAddress as StreetAddressOriginal,
  AddressLocation as AddressLocationOriginal,
  Subdivision as SubdivisionOriginal,
  CustomFormField as CustomFormFieldOriginal,
  ValueType as ValueTypeOriginal,
  ValueTypeWithLiterals as ValueTypeWithLiteralsOriginal,
  BookingStatus as BookingStatusOriginal,
  BookingStatusWithLiterals as BookingStatusWithLiteralsOriginal,
  PaymentStatus as PaymentStatusOriginal,
  PaymentStatusWithLiterals as PaymentStatusWithLiteralsOriginal,
  SelectedPaymentOption as SelectedPaymentOptionOriginal,
  SelectedPaymentOptionWithLiterals as SelectedPaymentOptionWithLiteralsOriginal,
  BookingSource as BookingSourceOriginal,
  Platform as PlatformOriginal,
  PlatformWithLiterals as PlatformWithLiteralsOriginal,
  Actor as ActorOriginal,
  ActorWithLiterals as ActorWithLiteralsOriginal,
  ParticipantNotification as ParticipantNotificationOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  IdentityType as IdentityTypeOriginal,
  IdentityTypeWithLiterals as IdentityTypeWithLiteralsOriginal,
  FlowControlSettings as FlowControlSettingsOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  ParticipantChoices as ParticipantChoicesOriginal,
  ServiceChoices as ServiceChoicesOriginal,
  ServiceChoice as ServiceChoiceOriginal,
  ServiceChoiceChoiceOneOf as ServiceChoiceChoiceOneOfOriginal,
  Duration as DurationOriginal,
  DateTimeRule as DateTimeRuleOriginal,
  ParticipantsRange as ParticipantsRangeOriginal,
  MultiServiceBookingInfo as MultiServiceBookingInfoOriginal,
  BookedAddOn as BookedAddOnOriginal,
  ZonedDate as ZonedDateOriginal,
  AllowedActions as AllowedActionsOriginal,
  Attendance as AttendanceOriginal,
  ConferencingDetails as ConferencingDetailsOriginal,
  BookingPolicySettings as BookingPolicySettingsOriginal,
  BookingFeeDetails as BookingFeeDetailsOriginal,
  BookingFeeStatus as BookingFeeStatusOriginal,
  BookingFeeStatusWithLiterals as BookingFeeStatusWithLiteralsOriginal,
  Order as OrderOriginal,
  OrderStatus as OrderStatusOriginal,
  OrderStatusWithLiterals as OrderStatusWithLiteralsOriginal,
  PaymentStatusEnumPaymentStatus as PaymentStatusEnumPaymentStatusOriginal,
  PaymentStatusEnumPaymentStatusWithLiterals as PaymentStatusEnumPaymentStatusWithLiteralsOriginal,
  Price as PriceOriginal,
  PriceDescription as PriceDescriptionOriginal,
  Balance as BalanceOriginal,
  AdditionalFee as AdditionalFeeOriginal,
  CouponInfo as CouponInfoOriginal,
  Waiver as WaiverOriginal,
  Status as StatusOriginal,
  StatusWithLiterals as StatusWithLiteralsOriginal,
  OrderTransactions as OrderTransactionsOriginal,
  MembershipPaymentDetails as MembershipPaymentDetailsOriginal,
  MembershipName as MembershipNameOriginal,
  MembershipPaymentCredits as MembershipPaymentCreditsOriginal,
  FormSubmission as FormSubmissionOriginal,
  SubscriptionInfo as SubscriptionInfoOriginal,
  Frequency as FrequencyOriginal,
  FrequencyWithLiterals as FrequencyWithLiteralsOriginal,
  SubscriptionStatus as SubscriptionStatusOriginal,
  SubscriptionStatusWithLiterals as SubscriptionStatusWithLiteralsOriginal,
  CyclePrice as CyclePriceOriginal,
  DeferredChargeInfo as DeferredChargeInfoOriginal,
  DeferredChargeInfoStatusDetailsOneOf as DeferredChargeInfoStatusDetailsOneOfOriginal,
  QueryExtendedBookingRequest as QueryExtendedBookingRequestOriginal,
  QueryV2 as QueryV2Original,
  QueryV2PagingMethodOneOf as QueryV2PagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CommonAddressLocation as CommonAddressLocationOriginal,
  Paging as PagingOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryExtendedBookingResponse as QueryExtendedBookingResponseOriginal,
  PagingMetadataV2 as PagingMetadataV2Original,
  Cursors as CursorsOriginal,
  QueryExtendedBookingsRequest as QueryExtendedBookingsRequestOriginal,
  CommonQueryV2 as CommonQueryV2Original,
  CommonQueryV2PagingMethodOneOf as CommonQueryV2PagingMethodOneOfOriginal,
  CommonPaging as CommonPagingOriginal,
  QueryExtendedBookingsResponse as QueryExtendedBookingsResponseOriginal,
  CountExtendedBookingsRequest as CountExtendedBookingsRequestOriginal,
  CountExtendedBookingsResponse as CountExtendedBookingsResponseOriginal,
  SearchExtendedBookingsRequest as SearchExtendedBookingsRequestOriginal,
  CursorSearch as CursorSearchOriginal,
  CursorSearchPagingMethodOneOf as CursorSearchPagingMethodOneOfOriginal,
  Aggregation as AggregationOriginal,
  AggregationKindOneOf as AggregationKindOneOfOriginal,
  RangeBucket as RangeBucketOriginal,
  SortType as SortTypeOriginal,
  SortTypeWithLiterals as SortTypeWithLiteralsOriginal,
  SortDirection as SortDirectionOriginal,
  SortDirectionWithLiterals as SortDirectionWithLiteralsOriginal,
  MissingValues as MissingValuesOriginal,
  MissingValuesWithLiterals as MissingValuesWithLiteralsOriginal,
  IncludeMissingValuesOptions as IncludeMissingValuesOptionsOriginal,
  ScalarType as ScalarTypeOriginal,
  ScalarTypeWithLiterals as ScalarTypeWithLiteralsOriginal,
  Interval as IntervalOriginal,
  IntervalWithLiterals as IntervalWithLiteralsOriginal,
  ValueAggregation as ValueAggregationOriginal,
  ValueAggregationOptionsOneOf as ValueAggregationOptionsOneOfOriginal,
  NestedAggregationType as NestedAggregationTypeOriginal,
  NestedAggregationTypeWithLiterals as NestedAggregationTypeWithLiteralsOriginal,
  RangeAggregation as RangeAggregationOriginal,
  ScalarAggregation as ScalarAggregationOriginal,
  DateHistogramAggregation as DateHistogramAggregationOriginal,
  NestedAggregationItem as NestedAggregationItemOriginal,
  NestedAggregationItemKindOneOf as NestedAggregationItemKindOneOfOriginal,
  AggregationType as AggregationTypeOriginal,
  AggregationTypeWithLiterals as AggregationTypeWithLiteralsOriginal,
  NestedAggregation as NestedAggregationOriginal,
  GroupByAggregation as GroupByAggregationOriginal,
  GroupByAggregationKindOneOf as GroupByAggregationKindOneOfOriginal,
  SearchDetails as SearchDetailsOriginal,
  Mode as ModeOriginal,
  ModeWithLiterals as ModeWithLiteralsOriginal,
  SearchExtendedBookingsResponse as SearchExtendedBookingsResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  AggregationData as AggregationDataOriginal,
  ValueAggregationResult as ValueAggregationResultOriginal,
  RangeAggregationResult as RangeAggregationResultOriginal,
  CommonScalarType as CommonScalarTypeOriginal,
  CommonScalarTypeWithLiterals as CommonScalarTypeWithLiteralsOriginal,
  NestedAggregationResults as NestedAggregationResultsOriginal,
  NestedAggregationResultsResultOneOf as NestedAggregationResultsResultOneOfOriginal,
  CommonAggregationType as CommonAggregationTypeOriginal,
  CommonAggregationTypeWithLiterals as CommonAggregationTypeWithLiteralsOriginal,
  ValueResults as ValueResultsOriginal,
  RangeResults as RangeResultsOriginal,
  AggregationResultsScalarResult as AggregationResultsScalarResultOriginal,
  NestedValueAggregationResult as NestedValueAggregationResultOriginal,
  ValueResult as ValueResultOriginal,
  RangeResult as RangeResultOriginal,
  ScalarResult as ScalarResultOriginal,
  ScalarDateResult as ScalarDateResultOriginal,
  NestedResultValue as NestedResultValueOriginal,
  NestedResultValueResultOneOf as NestedResultValueResultOneOfOriginal,
  Results as ResultsOriginal,
  DateHistogramResult as DateHistogramResultOriginal,
  GeotileGridBucket as GeotileGridBucketOriginal,
  GroupByValueResults as GroupByValueResultsOriginal,
  DateHistogramResults as DateHistogramResultsOriginal,
  NestedResults as NestedResultsOriginal,
  AggregationResultsScalarDateResult as AggregationResultsScalarDateResultOriginal,
  GeotileGridResults as GeotileGridResultsOriginal,
  AggregationResults as AggregationResultsOriginal,
  AggregationResultsResultOneOf as AggregationResultsResultOneOfOriginal,
} from './bookings-reader-v2-extended-booking-extended-bookings.types.js';
